export const getSaninitizedClientID = (clientID: string) => {
  return clientID.replace(/\./g, '-');
};
